import { render, staticRenderFns } from "./MainLayout2.vue?vue&type=template&id=e6fe430e&scoped=true&"
import script from "./MainLayout2.vue?vue&type=script&lang=js&"
export * from "./MainLayout2.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout2.vue?vue&type=style&index=0&id=e6fe430e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fe430e",
  null
  
)

export default component.exports